import type { FC } from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import { useMeasureElement } from '@wix/da-hooks/pkg/useMeasureElement/useMeasureElement';
import BaseList from '../BaseList';
import OriginalListItem from '../../items/OriginalListItem';
import { getActiveSection, getOriginalsData } from '../../../../selectors/studio';
import { StudioSection } from '../../../../types/store';
import { Props } from '../../StudioDeviationList';
import { StudioDeviationListContext } from '../../context';

import s from './OriginalDeviationList.scss';

const OriginalDeviationList: FC<Props> = ({ deviations }) => {
  const { ref: actionsColRef, dimensions: actionsDimensions } =
    useMeasureElement({
      throttle: 250,
      throttleOptions: { trailing: true },
    });

  const activeSection = useSelector(getActiveSection);
  const originalsData = useSelector(getOriginalsData);
  const isUnlisted = activeSection === StudioSection.PRODUCTS_ORIGINAL_UNLISTED;

  return (
    <StudioDeviationListContext.Provider
      value={{
        actionsColRef,
        actionsColWidth:
          actionsDimensions.width && Math.floor(actionsDimensions.width),
      }}
    >
      <BaseList
        className={cn(s['list'], isUnlisted && s['unlisted'])}
        results={deviations}
        renderItem={(deviation, idx) => (
          <OriginalListItem
            key={deviation.deviationId}
            deviation={deviation}
            originalsData={originalsData?.[deviation.deviationId]}
            offset={idx}
            isUnlisted={isUnlisted}
          />
        )}
      />
    </StudioDeviationListContext.Provider>
  );
};
OriginalDeviationList.displayName = 'OriginalDeviationList';

export default OriginalDeviationList;
